export default {
  'commons.table.loadMore': 'Carregar Mais',
  'commons.noData': 'Não foram encontrados dados.',
  'commons.form.loading': 'Carregando',
  'commons.form.button.clean': 'Limpar',
  'commons.form.button.save': 'Salvar',
  'commons.form.button.close': 'Fechar',
  'commons.form.button.remove': 'Remover',
  'commons.form.button.search': 'Buscar',
  'commons.form.errors.requiredField': 'Este campo é obrigatório.',
  'commons.form.errors.invalidField': 'Este campo é inválido.',
  'commons.form.errors.maxLength':
    'Este campo deve possuir no máximo {max} caracteres',
  'commons.form.errors.minLength':
    'Este campo deve possuir no mínimo {min} caracteres',
  'commons.form.errors.percentageField':
    'Este valor não é uma porcentagem válida.',
  'commons.form.errors.percentageField.min': 'Porcentagem mínima 0%.',
  'commons.form.errors.percentageField.max': 'Porcentagem máxima 1000%.',
  'commons.form.error.validNumberField': 'Valor inválido',
  'commons.form.errors.requiredNcm': 'O NCM é obrigatório.',
  'commons.form.errors.requiredCest': 'O CEST é obrigatório.',
  'commons.form.errors.requiredCpf': 'O CPF é obrigatório.',
  'commons.form.errors.requiredRg': 'O RG é obrigatório.',
  'commons.form.errors.requiredDate': 'A data é obrigatória.',
  'commons.form.errors.requiredCep': 'O CEP é obrigatório.',
  'commons.form.errors.requiredCnpj': 'O CNPJ é obrigatório.',
  'commons.form.errors.requiredLicensePlate':
    'A placa do veículo é obrigatória.',
  'commons.form.errors.invalidNcm': 'O NCM é inválido.',
  'commons.form.errors.invalidCest': 'O CEST é inválido.',
  'commons.form.errors.invalidCpf': 'O CPF é inválido.',
  'commons.form.errors.invalidRg': 'O RG é inválido.',
  'commons.form.errors.invalidDate': 'A data é inválida.',
  'commons.form.errors.invalidCep': 'O CEP é inválido.',
  'commons.form.errors.invalidCnpj': 'O CNPJ é inválido',
  'commons.form.errors.invalidEmail': 'O e-mail é inválido',
  'commons.form.errors.invalidUrl': 'A url é inválida',
  'commons.form.errors.invalidLicensePlate': 'A placa do veículo é inválida.',
  'commons.form.notification.error': 'A requisição falhou.',
  'commons.form.notification.errorDescription':
    'Não foi possível enviar a requisição para o servidor.',
  'commons.list.filter.order': 'Ordem',
  'commons.form.message.error': 'Preencha todos os campos obrigatórios',
  'commons.list.filter.asc': 'Ascendente',
  'commons.list.filter.desc': 'Descendente',
  'commons.list.header.action': 'Ação',
  'commons.list.action.button.clock': 'Horários',
  'commons.list.action.button': 'Ver/Editar',
  'commons.list.action.button.view': 'Ver',
  'commons.list.action.button.remove': 'Remover',
  'commons.list.action.button.delete': 'Excluir',
  'commons.list.action.button.enable': 'Ativar',
  'commons.list.action.button.disable': 'Desativar',
  'commons.list.action.button.replicate': 'Replicar',
  'commons.page.button.generateReport': 'Gerar Relatório',
  'commons.page.button.generateBudget': 'Gerar Orçamento',
  'commons.page.button.Checklist': 'Checklist',
  'commons.report.modal.title': 'Gerar Relatório',
  'commons.report.modal.message.success': 'Relatório gerado com sucesso!',
  'commons.report.modal.message.error': 'Não foi possível gerar o relatório!',
  'commons.report.form.description': 'Descrição',
  'commons.report.form.type': 'Tipo de exportação',
  'commons.report.form.type.view': 'Apenas Visualizar',
  'commons.report.form.type.pdf': 'PDF',
  'commons.report.form.type.spreadsheet': 'Planilha',
  'commons.report.form.button.export': 'Exportar',
  'commons.report.form.button.print': 'Imprimir',
  'commons.modal.button.cancel': 'Cancelar',
  'commons.modal.button.next': 'Próximo',
  'commons.modal.button.back': 'Voltar',
  'commons.modal.button.save': 'Salvar',
  'commons.modal.contact.title': 'Novo Contato',
  'commons.modal.contact.form.name': 'Nome',
  'commons.modal.contact.form.department': 'Departamento',
  'commons.modal.contact.form.birthDate': 'Data de Nascimento',
  'commons.modal.contact.form.email': 'E-mail',
  'commons.modal.contact.form.gender': 'Sexo',
  'commons.modal.contact.form.gender.male': 'Masculino',
  'commons.modal.contact.form.gender.female': 'Feminino',
  'commons.modal.contact.form.receiveEmail': 'Recebe E-mail?',
  'commons.modal.contact.form.receiveEmail.true': 'Sim',
  'commons.modal.contact.form.receiveEmail.false': 'Não',
  'commons.modal.contact.form.details.title': 'Detalhes',
  'commons.modal.contact.form.contactList.status': 'Status',
  'commons.modal.contact.form.contactList.status.active': 'Ativo',
  'commons.modal.contact.form.contactList.status.inactive': 'Inativo',
  'commons.modal.contact.form.contactList.contactType': 'Tipo',
  'commons.modal.contact.form.contactList.contactType.email': 'E-mail',
  'commons.modal.contact.form.contactList.contactType.mobile': 'Celular',
  'commons.modal.contact.form.contactList.contactType.fax': 'Fax',
  'commons.modal.contact.form.contactList.contactType.phone': 'Telefone',
  'commons.modal.contact.form.contactList.contactType.whatsapp': 'Whatsapp',
  'commons.modal.contact.form.contactList.value': 'Valor',
  'commons.modal.contact.form.contactList.description': 'Descrição',
  'commons.modal.contact.form.contactList.addItem': 'Adicionar Item',
  'commons.modal.contact.added.message': 'Contato adicionado',
  'commons.modal.contact.added.description':
    'O contato foi adicionado com sucesso!',
  'commons.modal.contact.removed.message': 'Contato removido',
  'commons.modal.contact.removed.description':
    'O contato foi removido com sucesso!',
  'commons.modal.contact.updated.message': 'Contato atualizado',
  'commons.modal.contact.updated.description':
    'O contato foi atualizado com sucesso!',

  'commons.modal.address.added.message': 'Endereço adicionado',
  'commons.modal.address.added.description':
    'O endereço foi adicionado com sucesso!',
  'commons.modal.address.removed.message': 'Endereço removido',
  'commons.modal.address.removed.description':
    'O endereço foi removido com sucesso!',
  'commons.modal.address.updated.message': 'Endereço atualizado',
  'commons.modal.address.updated.description':
    'O endereço foi atualizado com sucesso!',

  'commons.address.remove.confirm.title': 'Remover endereço',
  'commons.address.remove.confirm.content':
    'Gostaria de remover o endereço selecionado?',

  'commons.report.view': 'Ver Relatório',
  'commons.report.viewPDF': 'Ver PDF',

  'commons.entity.save': 'Salvar',
  'commons.entity.create': 'Criar',
  'commons.entity.add': 'Adicionar',
  'commons.entity.update': 'Editar',
  'commons.entity.remove': 'Remover',
  'commons.entity.view': 'Ver',
  'commons.entity.search': 'Pesquisar',
  'commons.entity.viewEdit': 'Ver/Editar',
  'commons.entity.viewAll': 'Ver Todos',
  'commons.entity.edit': 'Editar',
  'commons.entity.report': 'Relatório',
  'commons.entity.situation': 'Situação',
  'commons.entity.status': 'Status',
  'commons.entity.active': 'Ativo',
  'commons.entity.inactive': 'Inativo',
  'commons.entity.value': 'Valor',
  'commons.entity.percent': 'Porcentagem',
  'commons.entity.send': 'Enviar',
  'commons.entity.help': 'Ajuda',
  'commons.entity.notifications': 'Notificações',
  'commons.entity.user': 'Usuário',
  'commons.entity.settings': 'Configurações',
  'commons.entity.total': 'Total',

  'commons.message.info.mobileTable':
    'Para melhor visualização das tabelas, use o dispositivo horizontalmente.',

  'commons.errors.generic.message': 'Erro',
  'commons.errors.generic.description':
    'O servidor não está disponível no momento.',

  'commons.errors.notFound': '{content} não encontrado!',

  'commons.errors.form.message': 'Atenção',
  'commons.errors.form.description': 'Informe os campos do formulário',

  'commons.archive.upload.message': 'Sucesso',
  'commons.archive.upload.description': 'Arquivo enviado.',

  'commons.archive.upload.error.message': 'Falha ao realizar upload de arquivo',
  'commons.archive.upload.error.description':
    'Desculpe, não foi possível enviar o arquivo para o servidor.',

  'commons.address': 'Endereço',
  'commons.address.cep': 'CEP',
  'commons.address.uf': 'UF',
  'commons.address.city': 'Cidade',
  'commons.address.district': 'Bairro',
  'commons.address.street': 'Logradouro',
  'commons.address.number': 'Número',
  'commons.address.complement': 'Complemento',

  'commons.contact': 'Contato',
  'commons.contacts': 'Contatos',
  'commons.contact.contactType': 'Tipo de Contato',
  'commons.contact.contactType.email': 'E-Mail',
  'commons.contact.contactType.mobile': 'Celular',
  'commons.contact.contactType.fax': 'Fax',
  'commons.contact.contactType.phone': 'Telefone',
  'commons.contact.contactType.whatsapp': 'WhatsApp',
  'commons.contact.contactType.foreign': 'Estrangeiro',
  'commons.contact.name': 'Nome',
  'commons.contact.value': 'Contato',

  'commons.others': 'Outros',

  'commons.options.yes': 'Sim',
  'commons.options.no': 'Não',

  'commons.date.weekdays.monday': 'Segunda-feira',
  'commons.date.weekdays.tuesday': 'Terça-feira',
  'commons.date.weekdays.wednesday': 'Quarta-feira',
  'commons.date.weekdays.thursday': 'Quinta-feira',
  'commons.date.weekdays.friday': 'Sexta-feira',
  'commons.date.weekdays.saturday': 'Sábado',
  'commons.date.weekdays.sunday': 'Domingo',

  'commons.clear.filters': 'Limpar Filtros',

  'reports.form.selectTheDesiredMonth': 'Selecione o mês desejado',
  'reports.form.in': 'De:',
  'reports.form.from': 'Até:',
  'reports.form.orSelectTheDesiredMonth': 'Ou marque o mês desejado',
  'reports.form.companies': 'Empresas',
  'reports.button.viewReport': 'Visualizar Relatório',
  'reports.button.pdf': 'Gerar PDF',
  'reports.button.csv': 'Gerar CSV',

  'commons.table.column.workOrder': 'Orçamento',
  'commons.table.column.description': 'Descrição',
  'commons.table.column.manufacturerCode': 'Cód. Fabricante',
  'commons.table.column.licensePlate': 'Placa',
  'commons.table.column.qtyRequested': 'Qtde. solicitada',
};
